<template>

  <div
    class="detail"
    v-loading='localLoading'
    element-loading-text="上传中，请稍后……"
  >
    <input
      id="fileMoreUpSendImg"
      style="display:none;"
      type="file"
      multiple="multiple"
      name="file"
      @change="onFileMoreUpSend($event)"
    >

    <div class="detail_el_scroll">
      <div class="uploadpic_title">
        <el-checkbox v-model="isChoiceFolder" />
        <span>同时保存至媒资库</span>
        <el-button
          v-if="!isUploading && isChoiceFolder"
          type="primary"
          style="height:32px;width:90px;padding:0;"
          @click.native='choiceMatterFolder()'
        >文件夹选择</el-button>
        <span
          class="folder_active"
          style="line-height:32px;"
        >{{ currentMatterFolder.currentFolderLocation }}</span>
        <span class="upload_pic_num">
          <span>图片数量：</span>
          <span class="folder_active">{{ imgList.length }}张</span>
        </span>

      </div>
      <div
        v-if="imgList.length === 0"
        class="upload_pic_button"
      >
        <div
          style="margin-bottom:20px"
          class="upload_pic_button_box"
          @click.stop="choiceUploadPic()"
        >
          <span class="el-icon-plus"></span>
        </div>
        <div>
          <span>拖入图片或点击后添加（按住Ctrl可以多选）</span>
        </div>
      </div>

      <div
        v-if="imgList.length > 0"
        class="bottom_button"
      >
        <div
          v-if="!isUploading"
          class="bottom_content left_info"
        >
          <el-checkbox
            v-model="isCheckedAll"
            @change="changeAllPic"
          >全选</el-checkbox>
          <span
            v-if="isShowOperateButton && isChoiceFolder"
            class="operate_button"
            @click.stop="batchChangePicInfo()"
          >批量修改信息</span>
          <span
            v-if="isShowOperateButton"
            class="operate_button"
            @click.stop="batchDeletePic()"
          >批量移除</span>
        </div>
        <div
          v-if="!isUploading"
          class="bottom_content right_button"
        >
          <el-button
            v-if="imgList.length < 50"
            type="primary"
            @click.native="choiceUploadPic()"
          >添加图片</el-button>
          <el-button
            type="primary"
            @click.native="sureUploadPic()"
          >确定上传</el-button>
        </div>
      </div>

      <div
        v-if="imgList.length > 0"
        class="upload_pic_list"
      >
        <div
          v-for="(item,index) in imgList"
          :key="index"
          class="each_upload_pic"
        >
          <img
            :src="item.url"
            :title="item"
            class="img_box"
            alt=""
          >
          <div
            v-if="!isUploading"
            class="check_box"
          >
            <el-checkbox v-model="item.isChoice" />
          </div>
          <!-- eslint-disable -->
          <div
            v-if="!isUploading"
            class="upload_opacity"
            @click.stop="choiceOrCancleCurrentPic(item)"
          >
            <div
              class="img_title"
              :title="item.title"
            >
              {{ item.title }}
            </div>
            <div class="editor_delete">
              <span
                v-if="isChoiceFolder"
                class="iconfont icon-bianji"
                @click.stop="editorImgInfo(item)"
              ></span>
              <span
                class="iconfont el-icon-delete"
                @click.stop="deleteCurrentPic(index)"
              ></span>
            </div>
          </div>

          <div
            v-if="isUploading"
            class="upload_pic_progress"
          >
            <el-progress
              :text-inside="true"
              :stroke-width="20"
              :percentage="item.progressBars"
              status="success"
            ></el-progress>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import * as api from '../../../api'
import { getUrlCode } from '../../../utils/index.js'
import logsMixins from '../../../mixins/logs'
let OSS = require('ali-oss')
export default {
  data () {
    return {
      isCheckedAll: false,
      uploadPicData: '',
      imgList: [],
      currentEditPic: '',
      aliyundata: '',
      isUploading: false,
      currentMatterFolder: '',
      isChoiceFolder: true,
      localLoading: false
    }
  },
  mixins: [logsMixins],
  computed: {
    isShowOperateButton () {
      var k = 0
      for (var i = 0; i < this.imgList.length; i++) {
        if (!this.imgList[i].isChoice) {
          k++
        } else {
          break
        }
      }
      if (k === this.imgList.length) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    imgList () {
      if (this.imgList.length > 50) {
        this.$notify.warning({
          title: '警告',
          message: '一次上传最多50张图片'
        })
        this.imgList = this.imgList.slice(0, 50)
      }
    }
  },
  mounted () {
    this.$root.eventHub.$on('setOrgpicModel', (data, dataList) => {
      this.currentEditPic = data
      this.imgList = dataList
    })
    this.$root.eventHub.$on('getCurrentMatterFolder', (data) => {
      if (this.$parent.visible) {
        this.currentMatterFolder = data
      }
    })
    var editortype = getUrlCode('editortype')
    if (editortype === 'documentrepo') {
      this.isChoiceFolder = false
    } else {
      this.isChoiceFolder = true
    }

  },

  destroyed () {
    this.$root.eventHub.$off('setOrgpicModel')
  },
  methods: {
    dragUploadPicture () {
      var dropbox = document.querySelector('.detail_el_scroll');
      dropbox.addEventListener('dragenter', this.onDrag, false);
      dropbox.addEventListener('dragover', this.onDrag, false);
      dropbox.addEventListener('drop', this.onDrop, false);
    },
    onDrag: function (e) {
      e.stopPropagation()
      e.preventDefault()
    },
    onDrop: function (e) {
      e.stopPropagation()
      e.preventDefault()
      var dt = e.dataTransfer
      var dtFiles = dt.files
      var option = {
        target: {
          files: dtFiles
        }
      }
      this.onFileMoreUpSend(option)
    },

    clearUploadData () {
      this.isCheckedAll = false
      this.uploadPicData = ''
      this.imgList = []
      this.currentEditPic = ''
      this.aliyundata = ''
      this.isUploading = false
      this.currentMatterFolder = ''
      this.isChoiceFolder = true
      this.localLoading = true
    },
    editorImgInfo (item) {
      this.$root.eventHub.$emit('changeUploadPicModel', item, this.imgList)
      this.currentEditPic = item
    },
    choiceUploadPic () {
      if (this.imgList.length >= 50) {
        this.$notify.warning({
          title: '警告',
          message: '图片最多只能选择50张'
        })
      } else {
        var fileName = document.getElementById('fileMoreUpSendImg')
        fileName.click()
      }
    },
    onFileMoreUpSend (event) {
      var files = event.target.files || event.srcElement.files
      var lengthNum = files.length
      for (var i = 0; i < lengthNum; i++) {
        const isJPG = files[i].type === 'image/jpeg'
        const isGIF = files[i].type === 'image/gif'
        const isPNG = files[i].type === 'image/png'
        const isBMP = files[i].type === 'image/bmp'
        const isJPGS = files[i].type === 'image/jpg'
        const isWEBP = files[i].type === 'image/webp'
        const isTIFF = files[i].type === 'image/tiff'
        const isLTwentyMb = files[i].size / 1024 / 1024 < 20
        if ((isJPG || isGIF || isPNG || isBMP || isJPGS || isWEBP || isTIFF) && isLTwentyMb) {
          var currentUrl = this.getObjectURL(files[i])
          var currentTitle = ''
          var posiNumPic = files[i].name.lastIndexOf('.')
          if (posiNumPic !== -1) {
            currentTitle = files[i].name.substring(0, posiNumPic)
          } else {
            currentTitle = files[i].name
          }
          this.imgList.push(
            {
              title: currentTitle,
              file_name: files[i].name,
              url: currentUrl,
              tagIds: [],
              tags: [],
              keywords: [],
              detail: '',
              isChoice: false,
              progressBars: 0,
              files: files[i]
            }
          )
        } else {
          if ((!isJPG && !isGIF && !isPNG && !isBMP && !isJPGS && !isWEBP && !isTIFF)) {
            this.$notify.warning({
              title: '警告',
              message: '请选择正确的图片格式文件'
            })
          }
          if (!isLTwentyMb) {
            this.$notify.warning({
              title: '警告',
              message: '图片大小不能超过20MB'
            })
          }
        }
      }
      var fileName = document.getElementById('fileMoreUpSendImg')
      fileName.value = ''
      this.isCheckedAll = false
    },
    /* eslint-disable */
    getObjectURL (file) {
      var url = null
      // 下面函数执行的效果是一样的，只是需要针对不同的浏览器执行不同的 js 函数而已
      if (window.createObjectURL != undefined) { // basic
        url = window.createObjectURL(file)
      } else if (window.URL != undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL != undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },
    changeAllPic (val) {
      if (val) {
        for (var i = 0; i < this.imgList.length; i++) {
          this.$set(this.imgList[i], 'isChoice', true)
        }
      } else {
        for (var j = 0; j < this.imgList.length; j++) {
          this.$set(this.imgList[j], 'isChoice', false)
        }
      }
    },
    batchChangePicInfo () {
      this.$root.eventHub.$emit('batchModifyInfoModel', this.imgList, 'uploadType')
    },
    deleteCurrentPic (index) {
      this.imgList.splice(index, 1)
    },
    batchDeletePic () {
      var arr = []
      for (var i = 0; i < this.imgList.length; i++) {
        if (!this.imgList[i].isChoice) {
          arr.push(this.imgList[i])
        }
      }
      this.imgList = arr
      this.isCheckedAll = false
    },
    sureUploadPic () {
      if (this.isChoiceFolder) {
        if (this.imgList.length > 0 && this.currentMatterFolder) {
          this.isUploading = true
          var option = {
            ...this.$store.getters.baseOption,
            'params': {
              'repoId': this.currentMatterFolder.id_repo, // 必须参数： 库 ID
              'folderId': this.currentMatterFolder.id, // 必须参数： 文件夹 ID
              'type': "picture"  // 必须参数： 附件类型, 图片: picture 附件: file
            }
          }
          api._post(_IMGFILEURL_ + 'uploader/get_sts_info', option).then((resp) => {
            if (resp.code === 200) {
              this.aliyundata = resp.data
              this.uploadFile(resp.data)
            } else {
              this.isUploading = false
            }
          }).catch((error) => {
            console.log(error)
          })

        } else if (this.imgList.length === 0) {
          this.$notify.warning({
            title: '警告',
            message: '请选择上传图片'
          })
        } else if (!this.currentMatterFolder) {
          this.$notify.warning({
            title: '警告',
            message: '请选择需要保存的素材文件夹'
          })
        }
      } else {
        if (this.imgList.length > 0) {
          this.$root.eventHub.$emit('localPicToeditorModel', this.imgList)
          this.localLoading = true
        } else {
          this.$notify.warning({
            title: '警告',
            message: '请选择上传图片'
          })
        }

      }

    },
    uploadFile (data) {
      var client = new OSS({
        region: data.region,
        accessKeyId: data.ossAuthStsInfo.accessKeyId,
        accessKeySecret: data.ossAuthStsInfo.accessKeySecret,
        stsToken: data.ossAuthStsInfo.securityToken,
        bucket: data.bucket_name
      })
      for (var i = 0; i < this.imgList.length; i++) {
        var posiNumPic = this.imgList[i].file_name.lastIndexOf('.')
        var locationName = ''
        if (posiNumPic !== -1) {
          locationName = new Date().getTime() + (Math.random() * 1000) + this.imgList[i].file_name.substring(posiNumPic)
        } else {
          locationName = this.imgList[i].file_name
        }
        this.$set(this.imgList[i], 'location', data.object_prefix + locationName)
        this.$set(this.imgList[i], 'origin_url', data.object_prefix + locationName)
      }
      this.uploadFileToOSS(this.imgList, client)
    },

    uploadFileToOSS (fileKeyName, client) {
      var self = this
      async function multipartUpload () {
        var list = []
        for (var i = 0; i < fileKeyName.length; i++) {
          try {
            let result = await client.multipartUpload(fileKeyName[i].location, fileKeyName[i].files, {
              progress: function (p) {
                fileKeyName[i].progressBars = Math.floor(p * 100)
              }
            })
            if (result.res.statusCode == 200) {
              console.log('成功')
            }
          } catch (e) {
            // 捕获超时异常
            if (e.code === 'ConnectionTimeoutError') {
              console.log("Woops,超时啦!");
              // do ConnectionTimeoutError operation
            }
            console.log(e)
          }
        }
        self.uploadSuccess()
      }
      multipartUpload()
    },
    choiceMatterFolder () {
      this.$root.eventHub.$emit('setMatterPositionModel', this.currentMatterFolder, 'picToMatter')
    },
    uploadSuccess () {
      var option = {
        ...this.$store.getters.baseOption,
        'params': {
          'repoId': this.currentMatterFolder.id_repo, // 必须参数： 库 ID
          'folderId': this.currentMatterFolder.id, // 必须参数： 文件夹 ID
          'type': "picture",  // 必须参数： 附件类型, 图片: picture 附件: file
          'contents': this.imgList
        }
      }
      api._post(_IMGFILEURL_ + 'uploader/attach_confirm', option).then((resp) => {
        if (resp.code === 200) {
          this.$emit('setLocalpicToeditor', resp.data)
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    choiceOrCancleCurrentPic (item) {
      this.$set(item, 'isChoice', !item.isChoice)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.detail
  position relative
  width 100%
  height 100%
  border-radius 6px
  background #FFFFFF
  box-shadow 0px 1px 4px 0px rgba(0, 0, 0, 0.35)
  .titles
    clear both
    box-sizing border-box
    padding 0 14px 0 14px
    height 48px
    background #fff
    box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.2)
    .title_name
      float left
      color #303133
      font-size 16px
      line-height 48px
    .iconfont
      float right
      color #606266
      font-size 22px
      line-height 48px
      cursor pointer
  .detail_el_scroll
    position relative
    box-sizing border-box
    height 100%
    .uploadpic_title
      position relative
      z-index 100
      clear both
      box-sizing border-box
      padding 20px
      span
        color #606266
        font-size 14px
      .folder_active
        color #688EFF
      .upload_pic_num
        float right
    .upload_pic_button
      position absolute
      top 0
      left 0
      z-index 99
      display flex
      flex-direction column
      justify-content center
      align-items center
      width 100%
      height 100%
      .upload_pic_button_box
        display flex
        justify-content center
        align-items center
        width 220px
        height 220px
        border 4px dashed #ccc
        cursor pointer
        .el-icon-plus
          color #ccc
          font-size 60px
      button
        padding 0px
        width 110px
        height 38px
        border 0
      span
        color #909399
        font-size 14px
    .bottom_button
      position absolute
      bottom 0
      left 0
      clear both
      box-sizing border-box
      padding-right 20px
      padding-left 20px
      width 100%
      height 60px
      .bottom_content
        display flex
        align-items center
        height 60px
      .right_button
        float right
        button
          padding 0
          width 110px
          height 38px
      .left_info
        float left
        .operate_button
          margin-left 20px
          color #F56969
          font-size 14px
          cursor pointer
    .upload_pic_list
      position relative
      clear both
      overflow auto
      height calc(100% - 120px)
      .each_upload_pic
        position relative
        display flex
        justify-content center
        align-items center
        float left
        margin-bottom 10px
        margin-left 10px
        width 180px
        height 140px
        border 1px solid #E3E3E3
        border-radius 5px
        &:hover
          .upload_opacity
            display block
        img
          max-width 180px
          max-height 140px
          object-fit contain
        .check_box
          position absolute
          top -10px
          left 0
        .upload_opacity
          position absolute
          top 0
          left 0
          display none
          width 100%
          height 100%
          background rgba(0, 0, 0, 0.5)
          cursor pointer
          .editor_delete
            position absolute
            right 10px
            bottom 6px
            span
              margin-left 4px
              color #fff
              cursor pointer
          .img_title
            overflow hidden
            box-sizing border-box
            margin-left 20px
            width 86%
            color #fff
            text-overflow ellipsis
            white-space nowrap
            font-size 14px
        .upload_pic_progress
          position absolute
          top 0px
          left 0px
          box-sizing border-box
          padding-top 60px
          width 100%
          height 100%
          background rgba(0, 0, 0, 0.4)
</style>
